import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

//Prime React Components
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

//Custom Validation
import { LoginValidate } from '../../config/Validate';

//API Constant Settings
import { LOGIN } from '../../config/ApiConstant';
import axiosInstance from '../../config/axiosInstance';

interface finalObj {
    mobile: any;
}

export const Login = () => {
    document.title = 'Login | GSPC';
    const [loginData, setLoginData] = useState<any>({});
    const [errors, setErrors] = useState<any>({});
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const toast = useRef<any>(null);

    useEffect(() => {
        const assignedMenu: any = localStorage.getItem('assigned_menu') ? localStorage.getItem('assigned_menu') : '';
        const assignedActions: any = localStorage.getItem('assigned_actions') ? localStorage.getItem('assigned_actions') : '';
        const token: any = localStorage.getItem('token') ? localStorage.getItem('token') : '';
        const role: any = localStorage.getItem('role') ? localStorage.getItem('role') : '';
        const userId: any = localStorage.getItem('user') ? localStorage.getItem('user') : '';
        const name: any = localStorage.getItem('name') ? localStorage.getItem('name') : '';
        const email: any = localStorage.getItem('email') ? localStorage.getItem('email') : '';

        if (!window.cn(assignedMenu) && !window.cn(assignedActions) && !window.cn(token) && !window.cn(role) && !window.cn(userId) && !window.cn(name) && !window.cn(email)) {
            window.location.href = '/dashboard';
        }
    }, []);

    const navigate = useNavigate();

    // handle Change
    const _onHandleChange = (e: any, name: string) => {
        const val = (e.target && e.target.value) || '';
        setLoginData({ ...loginData, [name]: val });
    };

    //on submit button event
    const onSubmit = async () => {
        try {
            const { errors, isError } = LoginValidate(loginData);
            setErrors(errors);

            if (!isError) {
                setButtonLoading(true);

                //Create Request Data Object
                const Obj: finalObj = {
                    mobile: loginData?.mobile
                };

                //API Call
                const response = await axiosInstance.post(LOGIN, Obj);

                //Get API Response
                if (response) {
                    navigate(`/otp/${window.btoa(loginData?.mobile)}`);
                    setButtonLoading(false);
                }
            }
        } catch (error: any) {
            setButtonLoading(false);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: error.response.data.error });
        }
    };

    return (
        <div className="login-body">
            <div className="login-panel p-fluid">
                <Toast ref={toast} />
                <div>
                    <div className="logo-container">
                        <img src="/assets/images/gspc_new_logo.jpg" className="login-logo" alt="login-logo" />
                    </div>

                    <div className="mt-5">
                        <div className="field">
                            <InputText
                                value={!window.cn(loginData.mobile) ? loginData?.mobile : ''}
                                keyfilter={'num'}
                                name="mobile"
                                autoComplete="off"
                                placeholder="Enter Mobile No"
                                onChange={(e) => _onHandleChange(e, 'mobile')}
                                className={errors['mobile'] && 'p-invalid'}
                            />
                            <small className="p-invalid-txt d-flex">{errors['mobile']}</small>
                        </div>

                        <div className="button-container">
                            <Button type="button" label="Login" loading={buttonLoading} onClick={onSubmit}></Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
